import { DatePipe } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit, Optional } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { CustomValidator } from "../../_common/customvalidators";
import { URLS } from "../../_config/api.config";
import { ApiService } from "../../_services/api-data.service";
import { CommonService } from "../../_services/common.service";
import { ToastService } from "../../_services/toast.service";

@Component({
  selector: "app-add-featured-product",
  templateUrl: "./add-featured-product.component.html",
  styleUrls: [
    "./add-featured-product.component.scss",
    "./add-featured-product.component.overrides.scss",
  ],
})
export class AddFeaturedProductComponent implements OnInit, OnDestroy {
  public addProductForm: FormGroup;
  public subscription = new Subscription();
  endDate: any;
  startDate: any;
  isEdit = false;
  editData: any;
  currencySymbol: any = "";
  selectedProducts = [];
  pageno = 1;
  pagesize = 10;
  searchText: any;
  filterparams: any;
  searchObj: any = {};
  selectInterface = { cssClass: "custom-select-dd" };
  public totalItems = 0;
  public addFpItemsPerPage = 10;
  public addFpCurrentPage = 1;
  public validation_messages = {
    product_start_date_input: [
      {
        type: "required",
        message: "featuresProductsComponent.errors.startDateRequired",
      },
    ],
    product_end_date_input: [
      {
        type: "required",
        message: "featuresProductsComponent.errors.endDateRequired",
      },
    ],
    commission: [
      {
        type: "required",
        message: "featuresProductsComponent.errors.commissionRequired",
      },
      {
        type: "min",
        message: "featuresProductsComponent.errors.commissionMin",
      },
      {
        type: "max",
        message: "featuresProductsComponent.errors.commissionMax",
      },
      {
        type: "invalidNumber",
        message: "featuresProductsComponent.errors.commissionInvalid",
      },
    ],
  };
  minDate: any;
  todaysDate = new Date();

  productList = [];
  isSaving = false;
  isProductListLoading = false;

  constructor(
    private formBuilder: FormBuilder,
    private dataService: ApiService,
    public commonService: CommonService,
    @Optional() private dialogRef: MatDialogRef<AddFeaturedProductComponent>,
    private toastService: ToastService,
    private datePipe: DatePipe,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    private dialogData: { isEdit?: boolean; editData?: any },
  ) {
    this.isEdit = !!dialogData?.isEdit;
    this.editData = dialogData?.editData;
  }

  ngOnInit() {
    this.addProductForm = this.initializeForm();
    this.minDate = this.datePipe.transform(this.todaysDate, "YYYY-MM-dd");

    this.searchText = null;
    let params = {
      page: 1,
      size: 10,
      status: "approved",
    };
    if (this.editData) {
      this.addProductForm = this.initializeForm(this.editData);
    } else {
      this.getProductList(params);
    }
  }

  initializeForm(data?) {
    if (data) {
      this.startDate = data.start_date;
      this.endDate = data.end_date;
    }
    return this.formBuilder.group({
      product_start_date: new FormControl(
        { value: data && data.start_date ? data.start_date : null },
        {
          validators: Validators.compose([Validators.required]),
        },
      ),
      product_start_date_input: new FormControl(
        data && data.start_date
          ? this.datePipe.transform(data.start_date, "MMM d, y")
          : null,
        {
          validators: Validators.compose([Validators.required]),
        },
      ),
      product_end_date: new FormControl(
        { value: data && data.end_date ? data.end_date : null },
        {
          validators: Validators.compose([Validators.required]),
        },
      ),
      product_end_date_input: new FormControl(
        data && data.end_date
          ? this.datePipe.transform(data.end_date, "MMM d, y")
          : null,
        {
          validators: Validators.compose([Validators.required]),
        },
      ),
      commission: new FormControl(
        data && data.commission_percent ? +data.commission_percent : null,
        {
          validators: Validators.compose([
            Validators.required,
            Validators.min(0),
            Validators.max(99),
            CustomValidator.decimalNumberValidator,
          ]),
        },
      ),
    });
  }

  onSubmit() {
    if (!this.isEdit) {
      this.addProductForm.controls["product_start_date"].setValue(
        this.startDate,
      );
      this.addProductForm.controls["product_start_date_input"].setValue(
        this.startDate,
      );
      this.addProductForm.controls["product_end_date"].setValue(this.endDate);
      this.addProductForm.controls["product_end_date_input"].setValue(
        this.endDate,
      );
    }
    for (const i in this.addProductForm.controls) {
      this.addProductForm.controls[i].markAsDirty();
      this.addProductForm.controls[i].updateValueAndValidity();
      this.addProductForm.controls[i].markAsTouched();
    }
    if (this.addProductForm.invalid) {
      return;
    }
    if (this.isEdit) {
      this.addProductForm.controls["product_start_date"].setValue(
        this.startDate,
      );
      this.addProductForm.controls["product_start_date_input"].setValue(
        this.startDate,
      );
      this.addProductForm.controls["product_end_date"].setValue(this.endDate);
      this.addProductForm.controls["product_end_date_input"].setValue(
        this.endDate,
      );
    }
    if (!this.selectedProducts.length && !this.isEdit) {
      this.toastService.displayToast("error.minOneProduct", null, "danger");
      return;
    }
    if (
      (this.startDate && !this.endDate) ||
      (!this.startDate && this.endDate)
    ) {
      if (!this.startDate) {
        this.toastService.displayToast("error.selectStartDate", null, "danger");
      }
      if (!this.endDate) {
        this.toastService.displayToast("error.selectEndDate", null, "danger");
      }
      return;
    }
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      this.toastService.displayToast("error.startDateGreater", null, "danger");
      return;
    }
    if (this.addProductForm.value.commission > 100) {
      this.toastService.displayToast("error.commissionPercent", null, "danger");
      return;
    }
    if (this.isEdit) {
      const params = {
        request_id: this.editData.request_id,
        commission_request_percentage: +this.addProductForm.value.commission,
        start_date: this.datePipe.transform(this.startDate, "yyyy-MM-dd"),
        end_date: this.datePipe.transform(this.endDate, "yyyy-MM-dd"),
      };
      this.isSaving = true;
      this.subscription.add(
        this.dataService.post(URLS.updateFeaturedProduct, params).subscribe(
          (data) => {
            if (data && data["code"] == 200) {
              this.close(true);
            } else {
              this.isSaving = false;
              this.toastService.displayToast(data["message"], null, "danger");
            }
          },
          (error) => {
            this.isSaving = false;
            this.toastService.displayToast(error["message"], null, "danger");
          },
        ),
      );
    } else {
      const params = {
        product_id: this.selectedProducts,
        commission_request_percentage: +this.addProductForm.value.commission,
        start_date: this.datePipe.transform(this.startDate, "yyyy-MM-dd"),
        end_date: this.datePipe.transform(this.endDate, "yyyy-MM-dd"),
      };
      this.isSaving = true;
      this.subscription.add(
        this.dataService.post(URLS.addFeaturedProduct, params).subscribe(
          (data) => {
            if (data && data["code"] == 200) {
              this.close(true);
            } else {
              this.isSaving = false;
              this.toastService.displayToast(data["message"], null, "danger");
            }
          },
          (error) => {
            this.isSaving = false;
            this.toastService.displayToast(error["message"], null, "danger");
          },
        ),
      );
    }
  }

  prev() {
    // this.addProductForm.reset();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  selectCheckbox(checked: boolean, id: any) {
    if (checked) {
      if (!this.selectedProducts.includes(id)) {
        this.selectedProducts.push(id);
      }
    } else {
      let index = this.selectedProducts.indexOf(id);
      if (index >= 0) {
        this.selectedProducts.splice(index, 1);
      }
    }
  }

  close(updated?) {
    this.dialogRef?.close(updated);
  }

  onChange(event): void {
    this.addFpCurrentPage = event;
    this.pageno = event;
    let params = {
      page: event,
      size: this.pagesize,
      status: "approved",
    };
    this.getProductList(params, false);
  }

  getProductList(params?, clearFilter?: boolean) {
    if (this.searchObj) {
      params = { ...this.searchObj, ...params };
    }
    if (clearFilter) {
      params = {
        page: 1,
        size: this.pagesize,
      };
    }
    this.isProductListLoading = true;
    this.subscription.add(
      this.dataService.get(URLS.productList, params).subscribe(
        (data) => {
          if (data["code"] == 200) {
            this.productList = [];
            if (
              data["data"] &&
              data["data"]["result"] &&
              data["data"]["result"].length
            ) {
              let list = data["data"]["result"];
              list.forEach((element, index) => {
                let obj = {
                  product_id: element.product_id,
                  image:
                    element.images && element.images.length
                      ? element.images[0].image_url
                      : "./assets/images/empty-img.png",
                  name: this.commonService.domDirectionLTR
                    ? element.product_name_en
                      ? element.product_name_en
                      : "-"
                    : element.product_name_ar
                      ? element.product_name_ar
                      : "-",
                  qty: element.total_quantity ? element.total_quantity : 0,
                  qty_sold: element.quantity_sold ? element.quantity_sold : 0,
                  discount: element.discount ? element.discount : 0,
                  sku: element.product_sku ? element.product_sku : "",
                  price: element.price_per_unit ? element.price_per_unit : 0,
                  discounted_price: element.discounted_price
                    ? element.discounted_price
                    : 0,
                  updated_time: element.updated_at ? element.updated_at : "",
                  created_time: element.created_at ? element.created_at : "",
                  product_status: element.approval_status
                    ? element.approval_status
                    : "", //pending
                  category: this.commonService.domDirectionLTR
                    ? element.display_class_name_en
                      ? element.display_class_name_en
                      : "-"
                    : element.display_class_name_ar
                      ? element.display_class_name_ar
                      : "-",
                  subcategory: this.commonService.domDirectionLTR
                    ? element.display_sub_class_name_en
                      ? element.display_sub_class_name_en
                      : "-"
                    : element.display_sub_class_name_ar
                      ? element.display_sub_class_name_ar
                      : "-",
                };
                if (this.selectedProducts.includes(element.product_id)) {
                  obj["isChecked"] = true;
                }
                this.productList.push(obj);
              });
            }
            this.totalItems =
              data["data"] && data["data"]["total_count"]
                ? +data["data"]["total_count"]
                : 1;
            this.isProductListLoading = false;
          } else {
            this.isProductListLoading = false;
            this.toastService.displayToast(data["message"], null, "danger");
          }
        },
        (error) => {
          this.isProductListLoading = false;
          this.toastService.displayToast(error["message"], null, "danger");
        },
      ),
    );
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  search() {
    this.filterparams = {
      page: this.pageno,
      size: this.pagesize,
    };
    if (this.searchText && this.searchText.trim() == "") this.searchText = null;
    if (this.searchText) {
      this.searchObj["search"] = this.searchText.trim();
      this.getProductList(this.filterparams, false);
    } else {
      delete this.searchObj["search"];
      this.getProductList(
        { page: 1, size: this.pagesize, status: "approved" },
        false,
      );
    }
  }
  clearSearch() {
    this.searchText = null;
    let params = {
      page: 1,
      size: this.pagesize,
    };
    delete this.searchObj["search"];
    this.getProductList(params, false);
  }
}
